export default __webpack_public_path__ + "static/media/flutter.99b29fec.png";